/* eslint-disable react/prop-types */

const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

export const getPrintTemplate = ({
  headerInfo,
  rows,
  openingBalance,
  totalArisingBought,
  totalArisingSold,
  closingBalance,
}) => {
  // 1. Render các dòng phát sinh trong kỳ (Items)
  const rowsHtml = rows
    .map(
      (row) => `
      <tr>
        <td class="text-center">${row.recordingDate || ""}</td>
        <td class="text-center">${row.documentNumber || ""}</td>
        <td class="text-center">${row.documentDate || ""}</td>
        <td>${row.description || ""}</td>
        <td class="text-center">${row.correspondingAccount || ""}</td>
        
        <td class="text-right">${fmt(row.bought?.quantity)}</td>
        <td class="text-right">${fmt(row.bought?.amount)}</td>
        
        <td class="text-right">${fmt(row.sold?.quantity)}</td>
        <td class="text-right">${fmt(row.sold?.amount)}</td>
        
        <td class="text-right">${fmt(row.balance?.quantity)}</td>
        <td class="text-right">${fmt(row.balance?.amount)}</td>
      </tr>
    `
    )
    .join("");

  // 2. Render toàn bộ template HTML
  return `
    <html>
      <head>
        <title>In Sổ Chi Tiết Đầu Tư Chứng Khoán</title>
        <style>
          @media print {
            @page { margin: 10mm; size: landscape; }
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
          body {
            font-family: "Times New Roman", Times, serif;
            color: #000;
            padding: 0;
            margin: 0;
            font-size: 12px;
          }
          .header-top { display: flex; justify-content: space-between; margin-bottom: 15px; }
          .title-box { text-align: center; margin: 15px 0; }
          .title-main { font-size: 16px; font-weight: bold; margin: 0; text-transform: uppercase; }
          
          .info-block { width: 85%; margin: 0 auto 15px auto; line-height: 1.8; }
          .flex-row { display: flex; align-items: center; justify-content: space-between; }
          
          table { width: 100%; border-collapse: collapse; font-size: 11px; }
          th, td { border: 1px solid #000; padding: 5px 4px; }
          th { text-align: center; font-weight: bold; vertical-align: middle; }
          
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .text-left { text-align: left; }
          .bold { font-weight: bold; }
          .italic { font-style: italic; }
          
          .row-highlight td { font-weight: bold; background-color: #fafafa !important; }
          
          .footer-info { margin-top: 15px; line-height: 1.6; font-size: 12px; }
          .signature-section { display: flex; justify-content: space-between; margin-top: 25px; text-align: center; font-size: 12px; }
          .signature-box { width: 33%; }
          .signature-space { height: 60px; }
        </style>
      </head>
      <body>
        <div class="header-top">
          <div style="width: 45%;">
            <div class="bold" style="margin-bottom: 5px;">Đơn vị: ${
              headerInfo.company || ".............................."
            }</div>
            <div class="bold">Địa chỉ: ${
              headerInfo.companyAddress || ".............................."
            }</div>
          </div>
          <div style="text-align: center; width: 55%;">
            <div class="bold">Mẫu số S45-DN</div>
            <div class="italic" style="margin-top: 4px;">
              (Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
            </div>
          </div>
        </div>

        <div class="title-box">
          <h2 class="title-main">SỔ CHI TIẾT ĐẦU TƯ CHỨNG KHOÁN</h2>
          <div class="bold" style="margin-top: 5px;">(Dùng cho các TK: 121, 228)</div>
          
        </div>

        <div class="info-block">
          <div class="bold" style="text-align: center; margin-bottom: 5px;">
            Tài khoản: <span style="font-weight: normal; margin-left: 5px;">${
              headerInfo.account || "........................................"
            }</span>
          </div>
          <div class="flex-row">
            <div><span class="bold">Loại chứng khoán:</span> ${
              headerInfo.securityType || ".............................."
            }</div>
            <div><span class="bold">Đơn vị phát hành:</span> ${
              headerInfo.issuer || "............................................."
            }</div>
          </div>
          <div class="flex-row">
            <div><span class="bold">Mệnh giá:</span> ${
              fmt(headerInfo.parValue) || ".............................."
            }</div>
            <div><span class="bold">Lãi suất:</span> ${
              headerInfo.interestRate || "........................."
            }</div>
            <div><span class="bold">Thời hạn thanh toán:</span> ${
              headerInfo.paymentTerm || "........................."
            }</div>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th rowspan="3" style="width: 60px;">Ngày<br/>tháng<br/>ghi sổ</th>
              <th colspan="2">Chứng từ</th>
              <th rowspan="3" style="width: 180px;">Diễn giải</th>
              <th rowspan="3" style="width: 40px;">TK<br/>đối<br/>ứng</th>
              <th colspan="4">Số phát sinh</th>
              <th colspan="2">Số dư</th>
            </tr>
            <tr>
              <th rowspan="2" style="width: 50px;">Số<br/>hiệu</th>
              <th rowspan="2" style="width: 50px;">Ngày<br/>tháng</th>
              <th colspan="2">Mua vào</th>
              <th colspan="2">Xuất ra</th>
              <th rowspan="2" style="width: 60px;">Số<br/>lượng</th>
              <th rowspan="2" style="width: 90px;">Thành<br/>tiền</th>
            </tr>
            <tr>
              <th style="width: 60px;">Số<br/>lượng</th>
              <th style="width: 90px;">Thành<br/>tiền</th>
              <th style="width: 60px;">Số<br/>lượng</th>
              <th style="width: 90px;">Thành<br/>tiền</th>
            </tr>
            <tr style="background-color: #f0f0f0 !important;">
              <th>A</th>
              <th>B</th>
              <th>C</th>
              <th>D</th>
              <th>E</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th>5</th>
              <th>6</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-highlight">
              <td colspan="3"></td>
              <td>- Số dư đầu kỳ</td>
              <td colspan="5"></td>
              <td class="text-right">${fmt(openingBalance?.quantity)}</td>
              <td class="text-right">${fmt(openingBalance?.amount)}</td>
            </tr>

            <tr>
              <td colspan="3"></td>
              <td class="bold">- Số phát sinh trong kỳ:</td>
              <td colspan="7"></td>
            </tr>

            ${rowsHtml}

            <tr class="row-highlight">
              <td colspan="3"></td>
              <td>- Cộng số phát sinh</td>
              <td class="text-center">x</td>
              
              <td class="text-right">${fmt(totalArisingBought?.quantity)}</td>
              <td class="text-right">${fmt(totalArisingBought?.amount)}</td>
              
              <td class="text-right">${fmt(totalArisingSold?.quantity)}</td>
              <td class="text-right">${fmt(totalArisingSold?.amount)}</td>
              
              <td class="text-center">x</td>
              <td class="text-center">x</td>
            </tr>

            <tr class="row-highlight">
              <td colspan="3"></td>
              <td>- Số dư cuối kỳ</td>
              <td class="text-center">x</td>
              <td class="text-center">x</td>
              <td class="text-center">x</td>
              <td class="text-center">x</td>
              <td class="text-center">x</td>
              
              <td class="text-right">${fmt(closingBalance?.quantity)}</td>
              <td class="text-right">${fmt(closingBalance?.amount)}</td>
            </tr>
          </tbody>
        </table>

        <div class="footer-info">
          <div>- Sổ này có <span class="bold">${
            headerInfo.totalPages || "....."
          }</span> trang, đánh số từ trang 01 đến trang...</div>
          <div>- Ngày mở sổ: ${headerInfo.openingDate || ".............................."}</div>
        </div>

        <div class="signature-section">
          <div class="signature-box">
            <div class="bold">Người ghi sổ</div>
            <div class="italic">(Ký, họ tên)</div>
            <div class="signature-space"></div>
            <div>${headerInfo.preparerName || ""}</div>
          </div>
          <div class="signature-box">
            <div class="bold">Kế toán trưởng</div>
            <div class="italic">(Ký, họ tên)</div>
            <div class="signature-space"></div>
            <div>${headerInfo.chiefAccountantName || ""}</div>
          </div>
          <div class="signature-box">
            <div class="italic" style="margin-bottom: 4px;">
              Ngày ${headerInfo.signingDay || "..."} tháng ${
    headerInfo.signingMonth || "..."
  } năm ${headerInfo.signingYear || "..."}
            </div>
            <div class="bold">Người đại diện theo pháp luật</div>
            <div class="italic">(Ký, họ tên, đóng dấu)</div>
            <div class="signature-space" style="height: 40px;"></div>
            <div>${headerInfo.legalRepresentativeName || ""}</div>
          </div>
        </div>

        <script>
          // Tự động gọi lệnh in khi cửa sổ load xong
          window.onload = function() {
            setTimeout(() => {
              window.print();
            }, 500);
          };
        </script>
      </body>
    </html>
  `;
};
